module.exports = __webpack_public_path__ + "static/media/medium.65b14e87.png";